export enum FormOpenMode {
  /**
   * Default mode the form is editable from the start
   */
  Edit,

  /**
   * The form is readonly without the button to switch to edit
   */
  Readonly,
}
